import React from 'react'

import jared from "../img/jspool-icon.jpg";
import leslie from "../img/leslie-icon.png";
import summer from "../img/summer-icon.png";

import ccCSS from "../img/centercentreProjects/cc-css-development.png";
import ccremail from "../img/centercentreProjects/ccremail.png";
import ccremailBig from "../img/centercentreProjects/ccremailBig.png";
import uxStrategyProgram from "../img/centercentreProjects/uxstrategyprogram.png";
import win from "../img/centercentreProjects/winstakeholders.png";
import aux from "../img/aux-preview.png";
import gcev from "../img/gcev-preview.png";

import communityBig from "../img/centercentreProjects/communityBig.jpeg";
import agileBig from "../img/centercentreProjects/agileBig.png";
//import metricsBig from "../img/centercentreProjects/metricsBig.png";
//import hiringBig from "../img/centercentreProjects/hiringBig.png";
import researchBig from "../img/centercentreProjects/researchBig.png";
import goalsBig from "../img/centercentreProjects/goalsBig.png";

import communitySmall from "../img/centercentreProjects/communitySmall.png";
import agileSmall from "../img/centercentreProjects/agileSmall.png";
import metricsSmall from "../img/centercentreProjects/metricsSmall.png";
import metricsFigma from "../img/centercentreProjects/metricsFigma.png";
import hiringSmall from "../img/centercentreProjects/hiringSmall.png";
import researchSmall from "../img/centercentreProjects/researchSmall.png";
import goalsSmall from "../img/centercentreProjects/goalsSmall.png";

import gitOOPS from "../img/centercentreProjects/githubOOPS.png";
import figmaOOPS from "../img/centercentreProjects/oopsFigma.png";
import liveOOPS from "../img/centercentreProjects/liveOOPS.png";


import strategyProgram from "../img/projects/strategy-program.gif";




function About() {
    return (
        <div className="container" style={{ marginBottom: "200px" }}>
            <div className="w800">
                <p>Hi, I’m Marko, a software developer focused on enterprise digital platforms, scalable content systems, and high-performing web experiences. I work at Fidelity Investments as a Senior Manager, Web Designer, contributing to enterprise-scale modern web platform initiatives.</p>

                <p>I specialize in building scalable digital platforms and conversion-focused sales funnel systems that support lead generation, customer onboarding, and digital marketing workflows. My work combines frontend engineering, UX-driven thinking, and marketing technology to deliver performant, maintainable, and conversion-focused digital experiences.</p>

                <p><strong>My experience includes:</strong></p>
                <ul style={{ marginLeft: "20px", lineHeight: "1.8" }}>
                    <li>Custom Adobe Experience Manager (AEM) component development</li>
                    <li>Reusable component architecture</li>
                    <li>Enterprise CRM & CMS platforms</li>
                    <li>Frontend engineering</li>
                    <li>
                        <a href="https://mycredentials.ecornell.cornell.edu/credential/ArNtwlFZke" target="_blank" rel="noopener noreferrer">Systems thinking</a>

                    </li>
                    <li>SEO/GEO optimization</li>
                    <li><a href="https://stellarlanding.com/perfect-landing-page/" target="_blank" rel="noopener noreferrer">Conversion-focused user experiences</a></li>
                    <li>Scalable publishing workflows</li>
                    <li>Digital sales funnels (goHighLevel & SF) and landing page optimization</li>
                    <li>Cross-functional collaboration across engineering, sales, marketing, UX, and publishing teams</li>
                </ul>


                <p>My background spans enterprise publishing environments, digital marketing systems, and scalable web platform development. I enjoy building systems that balance technical quality, business goals, author usability, and long-term maintainability.</p>

                <h2>Leading Creative Teams </h2>
                <p>I had the privilege of working closely with UX thought leaders  <span className="tw-icon">
                    <img alt="Jared Spool Twitter Icon" src={jared} />
                </span>
                    <strong>Jared Spool</strong> (
                    <a
                        href="https://twitter.com/jmspool"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Jared Spool Twitter Profile"
                    >
                        @jmspool
                    </a>
                    ),
                    <span className="tw-icon">
                        <img src={leslie} alt="Leslie Jensen-Inman Twiter Icon" />
                    </span>{" "}
                    <strong>Leslie Jensen-Inman</strong> (
                    <a
                        href="https://twitter.com/jenseninman"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Leslie Jensen-Inman Twitter Profile"
                    >
                        @jenseninman
                    </a>
                    ), and
                    <span className="tw-icon">
                        <img src={summer} alt="Leslie Jensen-Inman Twiter Icon" />
                    </span>{" "}
                    <strong>Summer Kohlhorst</strong> (
                    <a
                        href="https://twitter.com/SummerKohlhorst/"
                        aria-label="Summer Kohlhorst Twitter Profile"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        @SummerKohlhorst
                    </a>
                    ), at Center Centre, where our team shared was driven by a bold mission: <i>eliminating bad design from the world</i>.</p>
                <p>I led development efforts focused on building and maintaining complete digital sales funnel ecosystems that connected marketing, lead generation, conversion, onboarding, and customer engagement into scalable digital platforms. Our digital experiences and educational platforms were designed for senior UX teams from organizations including Adobe, LinkedIn, and NASA JPL.</p>

            </div>



            <div className="w800" style={{ marginTop: "0px" }}>

                <p><strong>Featured Project: OOPPS. </strong>OOPPS is a conversion-focused webinar and plan-selling platform I designed and developed from the ground up. The project began as a (<a href="https://oopps-cs.xdmr.us/" target="_blank" rel="noopener noreferrer"><strong>UX Case Study</strong></a>) and evolved into a fully functional  ⚛️ {(/ /g, "\u00A0")}<a href="https://oops.xdmr.us/" target="_blank" rel="noopener noreferrer"><strong>React{(/ /g, "\u00A0")}App</strong></a> built with the React Context API and Vanilla CSS, featuring seamless Stripe API integration for payments and checkout flows.</p>



                <div className="flex" style={{ maxWidth: "700px", margin: "0 auto" }}>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="https://www.figma.com/file/fkA6RMJr5JC5KiiNP5RCZ3/Over-optimized-Plugin-for-(Webinar)-Plan-Selling---OOPS?node-id=202%3A626&t=P0XcyVZXHNZ6T3My-0"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Figma file that shows OOPS interface"
                                >
                                    <img
                                        src={figmaOOPS}
                                        alt="Screenshot of Figma file that shows OOPS interface"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="https://github.com/xdMR/overOptimizedPPS"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="github repo for OOPS project"
                                >
                                    <img
                                        src={gitOOPS}
                                        alt="Screenshot of OOPS project in Github"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="https://oops.xdmr.us"
                                    target="_blank"
                                    aria-label="deployed OOPS project"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={liveOOPS}
                                        alt="Screenshot of deployed OOPS project"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="w800"   >
                 <p style={{ marginTop: "80px" }}> <strong>Conversion-Focused:</strong> </p>
                <div className="flex" style={{ maxWidth: "700px", margin: "0 auto" }}>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="https://css-cc.pages.dev/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Screenshot of CenterCentreCSS Project"
                                >
                                    <img
                                        src={ccCSS}
                                        alt="CenterCentre CSS Framework"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="https://winstakeholders.pages.dev/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Screenshot of the landing page for Win Stakeholders and Inflience Decisions"
                                >
                                    <img
                                        src={win}
                                        alt="Win Stakeholders and Inflience Decisions"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="https://ux-strategy-program.pages.dev"
                                    target="_blank"
                                    aria-label="Screenshot of the landing page for UX Strategy Program"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={uxStrategyProgram}
                                        alt="UX Strategy Program"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex" style={{ maxWidth: "700px", margin: "0 auto" }}>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href={ccremailBig}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Screenshot of the landing page for Goals Program"
                                >
                                    <img
                                        src={ccremail}
                                        alt="Game-Changing Experience Vision Landing Page"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href={communityBig}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Screenshot of the landing page for Agile Program"
                                >
                                    <img
                                        src={communitySmall}
                                        alt="Taking Control of Agile UX Landing Page"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis30">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href="/strategy-program.mp4"
                                    target="_blank"
                                    aria-label="Screenshot of the landing page for Metrics Program"
                                    rel="noopener noreferrer"
                                >
                                    <img style={{ padding: "20px 0px", minHeight: "160px" }}
                                        src={strategyProgram}
                                        alt="Persuasive UX Metrics Landing Page"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="flex" style={{ maxWidth: "700px", margin: "0 auto" }}>

                    <div className="basis25">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href={agileBig}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Screenshot of the landing page for Agile Program"
                                >
                                    <img
                                        src={agileSmall}
                                        alt="Taking Control of Agile UX Landing Page"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis25">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href={researchBig}
                                    target="_blank"
                                    aria-label="Screenshot of the landing page for Research Program"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={researchSmall}
                                        alt="Advances Approach To UX Research"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis25">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href='https://www.figma.com/file/ba8hTYpbcXJRVcvfLCKSGP/Metrics-Intensive-Landing-Page-%5BLocked%5D?t=0pd8feXmiTEAUglR-1'
                                    target="_blank"
                                    aria-label="Screenshot of the landing page for Research Program"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={metricsFigma}
                                        alt="Advances Approach To UX Research"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="basis25">
                        <div className="preview-shadow">
                            <div className="uie-preview">
                                <a
                                    href={goalsBig}
                                    target="_blank"
                                    aria-label="Screenshot of the landing page for Research Program"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={goalsSmall}
                                        alt="Advances Approach To UX Research"
                                        className="img-resp "
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default About